import Phaser from 'phaser';
// Define a new class that extends Phaser.Scene
export default class BaseScene extends Phaser.Scene {
	// Define a constructor that takes a key parameter
	constructor(key) {
		super(key); // Call the constructor of the parent class with the key parameter
	}

	preload() {
		// Define a preload method
		// This method is empty, so it doesn't do anything
	}

	changeToScene(key, data = null) {
		// Define a method called changeToScene that takes a key and an optional data parameter
		// Remove all keyboard listeners
		this.input.keyboard.removeAllListeners();
		// Remove all input listeners
		this.input.removeAllListeners();
		// Stop all sounds (commented out)
		// this.game.sound.stopAll();
		// Pause the current scene
		this.scene.pause();
		// Check if the target scene is already paused
		if (this.scene.isPaused(key)) {
			// If it is, resume it with the data parameter
			this.scene.resume(key, data);
		} else {
			// If it isn't, launch it with the data parameter
			this.scene.launch(key, data);
		}
		// Bring the target scene to the top of the scene stack
		this.scene.bringToTop(key);
	}
}
